export default {
  hint: 'You are temporarily unable to access this page',
  reason: 'Here\'s why',
  noPage: 'This page does not exist',
  noPermission: 'You are not authorized to access this page',
  relation: 'If you have any questions, please contact your system administrator',
};
